import { ReactNode } from "react";
import { RequireAuth, RequireGroup } from "@jkast90/kast-common/auth";
import { authScreens } from "@jkast90/kast-common/ui";
import { isLocalDev } from "@common/auth/isLocalDev";
import { HNT_ADMIN_GROUPS, signIn, signOut } from "@common/auth/session";

const screens = authScreens({
  signIn: {
    onSignIn: () => signIn(),
    title: "Sign in to continue",
    detail:
      "The admin pages are for Hashers Not Trashers organizers. Sign in with your kast-dev account and you'll come back to this page.",
    signInLabel: "Sign in",
  },
  notAllowed: {
    title: "Access denied",
    group: ["HNT", "admin"],
    homeHref: "/",
    homeLabel: "Return home",
    onSwitchAccount: () => void signOut(),
    switchLabel: "Sign out",
  },
});

/**
 * The admin pages' gate: either role (site manager or full admin). The
 * session is loading only while a stored session that had already expired is
 * refreshed, so a signed-in admin never sees the prompt flash, and a
 * background refresh never takes the page down. Signed out, it asks to sign
 * in (and comes back to this page); signed in outside the groups, it says so.
 * Local dev takes no tokens, so it checks nothing.
 */
export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const authEnabled = !isLocalDev();
  return (
    <RequireAuth authEnabled={authEnabled} loading={screens.loading} prompt={screens.prompt}>
      <RequireGroup authEnabled={authEnabled} group={HNT_ADMIN_GROUPS} ignoreCase {...screens}>
        {children}
      </RequireGroup>
    </RequireAuth>
  );
}
